import React from 'react'
import "./QrCode.css"
const QrCode = () => {
  return (
    <div className='qrcode_handler'>
      <h1>Here's your Generated QR image</h1>
    </div>
  )
}

export default QrCode;